import React, { useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { ButtonColumn, Text } from '../../components/layout'
import { SelectField } from '../../components/layout/form/style/ReactSelect'
import { LocaleContext } from '../../util/locale'
import { Locale, LOCALES } from '../../types/locale'
import { languageSwitcherMessages } from './messages'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { LanguageSwitchingModal } from './LanguageSwitchingModal'

const SwitcherRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.25rem;
  }
`

const SelectContainer = styled.div`
  min-width: 140px;
`

interface LocaleOption {
  value: Locale
  label: string
}

const LOCALE_LABELS: Record<Locale, string> = {
  'fi-FI': 'Suomi',
  'sv-SE': 'Svenska',
  'en-US': 'English',
}

const options: LocaleOption[] = LOCALES.map(locale => ({ value: locale, label: LOCALE_LABELS[locale] }))

const MODAL_MIN_DURATION_MS = 1000

export const LanguageSwitcher: React.FunctionComponent = () => {
  const { locale, setLocale } = useContext(LocaleContext)
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  const currentOption = options.find(option => option.value === locale) ?? null
  const [showModal, setShowModal] = useState(false)

  return (
    <ButtonColumn>
      <SwitcherRow>
        <Text size="m">{formatMessage(languageSwitcherMessages.label)}</Text>
        <SelectContainer>
          <SelectField
            classNamePrefix="Select"
            isDisabled={showModal}
            isSearchable={false}
            isClearable={false}
            options={options}
            value={currentOption}
            onChange={(option: LocaleOption | null) => {
              if (!option) return
              setLocale(option.value)
              setShowModal(true)
              setTimeout(() => {
                window.location.reload()
              }, MODAL_MIN_DURATION_MS)
            }}
          />
        </SelectContainer>
      </SwitcherRow>
      {showModal && <LanguageSwitchingModal />}
    </ButtonColumn>
  )
}
